module.exports = __webpack_public_path__ + "static/machine-6cd220d5d23dabfa6a0f11f0e64e0253.png";